import React, { useEffect, useState } from "react";
import api from "../api"; 
import { Link } from "react-router-dom";

const SizeBrandList = () => {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const response = await api.get("/api/all-brands");
        setBrands(response.data);
      } catch (err) {
        console.error("Failed to load brands:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchBrands();
  }, []);

  if (loading) return <p className="text-center py-5">Loading brands...</p>;

  return (
    <div className="container py-5">
      <h2 className="text-center mb-4">All Brands</h2>
      <div className="row g-4">
        {brands && brands.length > 0 ? (
          brands.map((brand) => {
            const cleanBrand = encodeURIComponent(brand.brandName);

            const sizeChartUrl = `${api.defaults.baseURL}/api/size-charts/brand/${cleanBrand}/pdf`;

            return (
              <div
                key={brand.id || brand.brandName}
                className="col-6 col-sm-4 col-md-3 col-lg-2 d-flex justify-content-center"
              >
                <div className="brand-card text-center p-3 border rounded-3 bg-white shadow-sm">
                  
                  {/* Brand Link */}
                  <Link to={`/products/brand/${cleanBrand}`}>
                    <img
                      src={
                        brand.brand_img_url && brand.brand_img_url.trim() !== ""
                          ? brand.brand_img_url
                          : "/images/default-brand.png"
                      }
                      alt={brand.brandName}
                      className="img-fluid mb-2"
                      style={{ maxHeight: "100px", width: "150px", objectFit: "contain" }}
                      onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = "/images/no_image.jpg";
                      }}
                    />
                    <h6 className="mt-2 text-dark">{brand.brandName}</h6>
                  </Link>

                  {/* ⭐ Size Chart link */}
                  <p className="mt-1">
                    <a 
                      href={sizeChartUrl} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="small text-primary"
                    >
                      Size Chart
                    </a>
                  </p>

                </div>
              </div>
            );
          })
        ) : (
          <p className="text-center">No brands found.</p>
        )}
      </div>
    </div>
  );
};

export default SizeBrandList;
